export class ResponseWrapper<T> {

  resultList: T[];
  totalElements: number;
  size: number;
  page: number;
  additionalProperties: Map<string, any>;
  one : T;
  resultMessage : string;
  inError : boolean;
  enableCount : boolean;
  javaExcecptionClass : string;
  newObj:boolean;
  entityName:string;
  content: T[]; // dette technique : d'anciens endpoints utilisent ça

}
